import React from 'react';
import { ExportNotificationsProvider } from 'context/ExportNotificationsContext';
import { StudyNotificationsProvider } from 'context/StudyNotificationsContext';

/**
 * Composes all notification providers into a single component
 * Add new notification providers here to avoid deep nesting in App
 */
export const NotificationProviders = ({ userId, children }) => (
    <ExportNotificationsProvider userId={userId}>
        <StudyNotificationsProvider userId={userId}>
            {children}
        </StudyNotificationsProvider>
    </ExportNotificationsProvider>
);
